import React from 'react';

import Button from 'components/Button';

import './styles.css';

const KycDocumentUploadButtons = ({submitForm, submitDisabled, submitting}) => (
  <div className="KycDocumentUploadButtons">
    <Button
      blue={!submitDisabled}
      className="submit"
      onClick={submitForm}
      isLoading={submitting}
      disabled={submitDisabled}>
      Upload
    </Button>
  </div>
);

export default KycDocumentUploadButtons;
